module.exports = __webpack_public_path__ + "img/chara_3.6710c42e.png";